import type { PropsWithChildren } from "react";
import { Text } from "src/components/Text/Text.tsx";

export const HeaderCell = (props: PropsWithChildren) => {
  const { children } = props;
  return <Text fontWeight={"medium"}>{children}</Text>;
};
